import { HomeNavbar } from "../shared/navbar";
import styles from "./styles.module.scss";

export function DisclaimerPage() {
  return (
    <>
      <HomeNavbar />
      <main className={styles.main}>
        <h2>Flueid Disclaimer</h2>
        <p>
          The information provided is for your own internal business use and for informational purposes only. The
          information is deemed to be valid and reliable, but is not guaranteed. It is your sole responsibility to
          independently confirm and verify all information upon which you may rely or use from this software
          application. You may not transfer, sell, convey, use, resell, copy, transfer, publish, redistribute, reproduce
          or sublicense the information provided to you by Flueid or its licensees in any medium, form, manner or format
          whatsoever, for any purpose including, but not limited to the following: (i) reproduction, reformatting,
          publication, distribution or dissemination associated with any service or product provided or made available
          to any third party; (ii) for any other commercial purpose beyond internal business use; (iii) inclusion or in
          combination with any other service or product of any kind; and (iv) use of any portion of the information in
          conjunction with platforms that result in the sharing of the information outside of your internal business
          use, including, without limitation artificial intelligence applications, auto-generative systems, or similar
          language processing tools. There is no representation of warranty that the information is complete or free
          from error, and Flueid and its licensors do not assume, and expressly disclaims, any liability to any person
          or entity for loss or damage caused by errors or omissions in the information. Any use of the information
          provided must in all cases comply with all applicable laws and regulations.
        </p>
      </main>
    </>
  );
}
